import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { smithtownConfig } from "./data";

export default function SmithtownPage() {
  return <CityPageTemplate config={smithtownConfig} />;
}